import { createContext, useContext, useState } from 'react';

const HostAttendanceRecordContext = createContext();

const initialState = {
  tempCapturedImage: null,
  capturedImage: { first: null, second: null },
  shiftDate: null,
  note: '',
  currentStep: 0,
  locationRecord: null,
  isLoading: false,
  isPermissionDenied: false,
};

const HostAttendanceRecordProvider = ({ children }) => {
  const [state, setState] = useState(() => ({
    ...initialState,
  }));

  const updateState = (payload) => {
    setState((prev) => ({ ...prev, ...payload }));
  };

  const resetState = () => setState(initialState);

  return <HostAttendanceRecordContext.Provider value={{ updateState, resetState, state }}>{children}</HostAttendanceRecordContext.Provider>;
};

export const useHostAttendanceRecordState = () => {
  return useContext(HostAttendanceRecordContext);
};

export default HostAttendanceRecordProvider;
